import { render } from "./NewsContainer.vue?vue&type=template&id=b620ad7c"
import script from "./NewsContainer.vue?vue&type=script&lang=js"
export * from "./NewsContainer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tmulag_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__